import * as fromDatatype from "../../../../models/datatype-library";

export class PaymentStatementSearchDTO {
    guids?: string[]; // Converted from Set<UUID>
    hdr_ocr_guid?: string; // UUID
    scanned_doc_no?: string;
    entity_hdr_guids?: string[]; // Converted from Set<UUID>
    entity_code?: string;
    entity_name?: string;
    doc_reference_no?: string;
    company_guids?: string[]; // Converted from Set<UUID>
    company_code?: string;
    company_name?: string;
    amount_txn_excl_tax?: number; // Converted from BigDecimal
    amount_txn_incl_tax?: number; // Converted from BigDecimal
    remarks?: string;
    verification_status?: string;
    created_by_subject_guids?: string[]; // Converted from Set<UUID>
    updated_by_subject_guids?: string[]; // Converted from Set<UUID>
    start_date_to?: fromDatatype.TimestampTzDatatypeInterface; // ZonedDateTime
    start_date_from?: fromDatatype.TimestampTzDatatypeInterface; // ZonedDateTime
    end_date_to?: fromDatatype.TimestampTzDatatypeInterface; // ZonedDateTime
    end_date_from?: fromDatatype.TimestampTzDatatypeInterface; // ZonedDateTime
    b2b_matching_status?: string;
    einvoice_matching_status?: string;

    // Line-level data
    payment_request_stmt_line_guid?: string; // UUID
}